module.exports = __webpack_public_path__ + "img/basketball_player.e019e924.png";